module.exports = __webpack_public_path__ + "static/fonts/AppleSDGothicNeoSB.126e267.woff";